import { useDispatch, useSelector } from 'react-redux';
import { SelectInput } from '@interstate/components/SelectInput';
import { Box } from '@interstate/components/Box';
import * as proposalActionCreators from '@makemydeal/dr-dash-store/actions/proposalActionCreators';
import * as proposalSelectors from '@makemydeal/dr-dash-store/selectors/proposalSelectors';
import * as printPdfDealSelectors from '@makemydeal/dr-dash-store/selectors/printPdfDealSelectors';
import { useEffect } from 'react';
import { LoadingSection, LoadingSectionParent } from '@makemydeal/dr-shared-components';
import { Alert } from '@interstate/components/Alert';

interface PrintProposalSelectorProps {
    onProposalChange: (event: { target: { value: string | undefined } }) => void;
    selectedProposalId?: string;
}

export const PrintProposalSelector = ({ onProposalChange, selectedProposalId }: PrintProposalSelectorProps) => {
    const printingProposals = useSelector(proposalSelectors.getProposalList);
    const isLoadingProposals = useSelector(proposalSelectors.getProposalsLoading);
    const isLoadingProposalsError = useSelector(proposalSelectors.getProposalsError);
    const areAllScopesBalloonOrFlexBuy = useSelector(printPdfDealSelectors.getAreAllScopesBalloonOrFlexBuy);
    const dispatch = useDispatch();

    const primaryProposalId = useSelector(proposalSelectors.getPrimaryProposalId);

    useEffect(() => {
        dispatch(proposalActionCreators.getProposalList(areAllScopesBalloonOrFlexBuy ? 'standard' : undefined));
    }, [dispatch, areAllScopesBalloonOrFlexBuy]);

    useEffect(() => {
        if (primaryProposalId && selectedProposalId === undefined) {
            onProposalChange({ target: { value: primaryProposalId } });
        }
    }, [primaryProposalId, selectedProposalId, onProposalChange]);

    return (
        <LoadingSectionParent>
            <LoadingSection loading={isLoadingProposals} testId={'loading-proposals-loader'} size={70} />

            <Box sx={{ marginBottom: '1rem' }}>
                {isLoadingProposalsError ? (
                    <Alert type="error">Failed to retrieve list of proposals</Alert>
                ) : (
                    <SelectInput
                        id="printing-proposal-select"
                        label="Printing Proposal"
                        name="printing-proposal"
                        placeholder="Select a proposal type"
                        value={selectedProposalId ?? primaryProposalId}
                        onChange={onProposalChange}
                        options={printingProposals.map((proposal) => ({ label: proposal.title, value: proposal.id }))}
                        data-testid="printing-proposal-select"
                        displayDeselectOption={false}
                        disabled={isLoadingProposalsError}
                    />
                )}
            </Box>
        </LoadingSectionParent>
    );
};
